import { Flex, Layout } from 'antd';
import { styled } from 'styled-components';

export const Container = styled(Flex)`
  width: 100%;
  height: 64px;
  padding-right: 24px;
  background-color: ${(props) => props.theme.antd?.colorPrimaryActive};
`;

export const Logo = styled(Flex)`
  padding-left: 24px;
  color: ${(props) => props.theme.antd?.colorPrimary};
  cursor: pointer;
`;

export const Notification = styled(Flex)`
  padding: 0 5px;
  cursor: pointer;
`;

export const Avatar = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  background-color: ${(props) => props.theme.antd?.colorPrimary};
  align-items: center;
  justify-content: center;
  color: #fff;
`;

export const Header = styled(Layout.Header)`
  height: 64px;
  line-height: 64px;
  padding: 0 24px;
  background-color: #fff;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 18px;
`;
